import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Import Images
import software from "../../assets/images/software/TVekranCagrı.png";
import bgimg from "../../assets/images/software/bg.png";

class Section extends Component {

  render() {
    return (
      <React.Fragment>
        <section
          id="home"
          className="bg-half-260 bg-primary d-table w-100"
          style={{ background: `url(${bgimg}) center center` }}
        >
          <div className="bg-overlay"></div>
          <Container>
            <Row
              className="align-items-center position-relative"
              style={{ zIndex: "1", marginTop: "5px" }}
            >
              <Col lg="6" md="12">
                <div className="title-heading text-center text-lg-start">
                  <h1 className="heading mb-3 title-dark text-white">
                    Dijital Sıramatik ile Kuyruklarınızı <span className="text-warning">Dijitalleştirin</span>
                  </h1>
                  <p className="para-desc text-white-50">
                    Modern, hızlı ve kullanıcı dostu sıra yönetim sistemi. Sağlık kuruluşları, bankalar, 
                    kamu kurumları ve hizmet sektörü için tasarlanmış kapsamlı dijital sıra yönetim çözümü.
                  </p>
                </div>
              </Col>

              <Col lg="6" md="12" className="mt-4 pt-2">
                <div className="position-relative">
                  <div className="software_hero">
                    <img src={software} className="img-fluid d-block" alt="" />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
